import request from "../utils/businessservice";

export function getAllEstate_js(){

    return request({
        url: "prod-api/estate/reportingWarranty/list?pageNum=" + data.page + "&pageSize=" + data.pageSize + "&communityId=" + data.communityId, ///测试Api地址
        method: "get",
    });
}

export function getEstateAllComplaint(data) {
  return request({
    url: "/supervision/complant/suggestion/list?estateId="+data.estateId, ///业主投诉 "
    method: "get",
  });
}

export function getAllEstate(){
    return request({
        url: "/supervision/complant/allEstate", ///物业公司
        method: "get",
    });
}

export function addInterfere(data){
    return request({
        url: "/supervision/interfere/addInterfere", // 介入处理
        method: "post",
        data:data
    });
}

export function getWeekAdd(data){
    return request({
        url: "/supervision/complant/weekAdd?estateId="+data.estateId, //统计
        method: "get",
    });
}

export function interfereList(data){
    return request({
        url: "/supervision/interfere/list", //介入事件
        method: "get",
    });
}

export function financialReportList(data){
    return request({
        url: "/supervision/financialReport/list?reportFormsType=" + data.reportFormsType + "&searchValue=" + data.searchValue + "&uploadTime=" + data.uploadTime, //财报
        method: "GET"
    });
}

// 资金申请列表
export function fundlist(data){
    return request({
        url: "/supervision/fundapplication/listRecord?estateId=" + data.estateId + "&searchValue=" + data.searchValue + "&pageNum=" + data.pageNum + '&pageSize=' + 20, //财报
        method: "GET"
    });
}

// 资金申请详情
export function funddetail(data){
    return request({
        url: "/supervision/fundapplication/record/" + data.id, //财报
        method: "GET",
    });
}

// 资金申请审核
export function fundaudit(data){
    return request({
        url: "/supervision/fundapplication/record/handle", //财报
        method: "POST",
        data:data
    });
}
